import React from 'react';

type TooltipProps = {
  tooltipText: string;
  width?: string;
};

export default function Tooltip({ tooltipText, width }: TooltipProps) {
  return (
    <div className={`absolute -bottom-12 ${width ? width : 'w-auto'} bg-blue-200 p-3 rounded-md z-10 flex justify-center items-center group-hover:block transition-opacity flex`} style={{ right: '0', left: 'auto' }}>
      <p className="text-sm text-gray-700 text-center ">{tooltipText}</p>
    </div>
  );
}
